import { Globe, Users } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { NATIONALITIES } from './tripConstants';

export const NationalityStep = ({ formData, updateFormData, showOtherNationality, onNationalityChange }) => (
  <div className="space-y-6">
    <div className="flex items-center gap-3 mb-6">
      <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-sky to-ocean flex items-center justify-center text-white shadow-lg">
        <Globe className="w-6 h-6" />
      </div>
      <div>
        <h3 className="text-xl font-semibold text-ocean">What's your nationality?</h3>
        <p className="text-ocean/70 text-sm">We'll use this to provide visa requirements</p>
      </div>
    </div>
    
    <div className="space-y-4">
      <div className="bg-gradient-to-br from-sky/10 to-ocean/10 p-5 rounded-xl border border-ocean/20 backdrop-blur-sm">
        <Label htmlFor="nationality" className="text-ocean font-medium flex items-center gap-2">
          <Users className="w-4 h-4 text-sky" /> Your Nationality
        </Label>
        <Select value={showOtherNationality ? 'other' : formData.nationality} onValueChange={onNationalityChange}>
          <SelectTrigger className="input-field mt-2 bg-white/70" data-testid="nationality-select">
            <SelectValue placeholder="Select your nationality" />
          </SelectTrigger>
          <SelectContent className="max-h-[300px]">
            {NATIONALITIES.map((nationality) => (
              <SelectItem key={nationality} value={nationality}>{nationality}</SelectItem>
            ))}
            <SelectItem value="other" className="text-gold font-medium">
              Other (Enter manually)
            </SelectItem>
          </SelectContent>
        </Select>
      </div>

      {showOtherNationality && (
        <div className="bg-gradient-to-br from-gold/10 to-sky/10 p-5 rounded-xl border border-gold/20 backdrop-blur-sm">
          <Label htmlFor="custom-nationality" className="text-ocean font-medium">Enter Your Nationality</Label>
          <Input id="custom-nationality" value={formData.nationality}
            onChange={(e) => updateFormData('nationality', e.target.value)}
            placeholder="e.g., Luxembourger, Monegasque"
            className="input-field mt-2 bg-white/70" data-testid="custom-nationality-input" />
        </div>
      )}

      {formData.nationality && (
        <div className="mt-4 p-5 bg-gradient-to-br from-ocean/15 to-gold/10 rounded-xl border border-ocean/30 backdrop-blur-sm">
          <p className="text-sm text-ocean/70 mb-1">Your nationality</p>
          <p className="font-serif text-2xl text-ocean flex items-center gap-2">
            {formData.nationality}
          </p>
          <p className="text-sm text-ocean/60 mt-2">
            This helps us provide accurate visa requirements for your destination.
          </p>
        </div>
      )}
    </div>
  </div>
);
